import detectLang from 'toxilibs/language_detector.js'


const {origin, pathname, search, hash} = window.location

const lang = detectLang({
    accepted: ['en', 'pl'],
    default:  'en'
})

window.location.replace(origin + '/' + lang + pathname + search + hash)
